/**
 * 드래그 정렬만 필요한 단순 인덱스 페이지 공용 컨트롤러 shim.
 *
 * 벌크삭제/페이지이동 없이 [data-sortable-tbody] 정렬만 쓰는 페이지(연구 그룹·CP·수상,
 * 장비 공지/교육 등)에서, PHP 컨트롤러 short class name 을 이 객체에 매핑해
 * index() 진입 시 SortableList 를 붙인다. (PageMove/BulkSelect 는 전역 init 가 담당.)
 *
 * ControllerRegistry 에서 여러 이름이 이 한 객체를 가리킨다.
 */
import { Logger } from "../../utils/Logger";
import { AdminIndexTable } from "../components/AdminIndexTable";

export const AdminSortableIndexController = {
    index(): void {
        Logger.debug("AdminSortableIndexController.index");
        new AdminIndexTable().init();
    },
};
